module.exports = __webpack_public_path__ + "img/组 4.31c6b169.webp";